import React, { useState } from 'react';
import classes from './ScratchGames.module.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useSelector } from 'react-redux';

export default function BingoAlphabet() {
  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector((state) => state.scratch.token);


  window.onmessage = function (e) {
    if (e.data === 'noScrollBehaviour') {
      document.body.classList.add('noscroll');
    }
    if (e.data === 'ScrollBehaviour') {
      document.body.classList.remove('noscroll');
    }
  };

  return (
    <>
      <Header />
      <div className={classes.Iframe}>
        {isLoading && (
          <div className="loaderScratch">Loading bingo Alphabet game...</div>
        )}
        <iframe
          title="Bingo Alphabet Game"
          src={`https://bingoalphabet-demo.moobitek.com?token=${token}`}
          width="100%"
          height="100%"
          allow="autoplay"
          onLoad={() => setIsLoading(false)}
          style={{
            display: isLoading ? 'none' : 'block',
            border: 'none',
          }}
        ></iframe>
      </div>
      <Footer />
    </>
  );
}
